// Footer height for fix footer
var $ = require('jquery');

setTimeout( function() {
	$('footer .icon-text').hide();

	var footerHeight = $("footer").height();
	$('body').css('padding-bottom', footerHeight);
}, 1500);

$(window).resize(function() {
	var footerHeight = $("footer").height();
	$('body').css('padding-bottom', footerHeight);
});